export const WarehouseTargetsColConfig = [
  {
    name_of_db_column: 'warehouseId',
    label_of_column: 'WAREHOUSE ID',
    order_of_column: 1,
  },
  {
    name_of_db_column: 'warehouseName',
    label_of_column: 'Name',
    order_of_column: 2,
  },
  {
    name_of_db_column: 'deliveryService',
    label_of_column: 'DELIVERY SERVICE',
    order_of_column: 3,
  },
  {
    name_of_db_column: 'deliveryDays',
    label_of_column: 'DELIVERY DAYS',
    order_of_column: 4,
  },
  {
    name_of_db_column: 'cutOffTime',
    label_of_column: 'CUTOFF TIME',
    order_of_column: 5,
  },
  {
    name_of_db_column: 'businessCategory',
    label_of_column: 'BUSINESS CATEGORY',
    order_of_column: 6,
  },
  {
    name_of_db_column: 'creationDate',
    label_of_column: 'CREATION DATE',
    order_of_column: 7,
  },
  {
    name_of_db_column: 'lastUpdated',
    label_of_column: 'LAST UPDATED',
    order_of_column: 8,
  },
]
